import angular from 'angular';

import CashFlowChartComponent from './cash-flow-chart.cmpt';

export default angular
    .module('application.scene.authorized.scene.dashboard.component.cash-flow-chart', [])
    .component(CashFlowChartComponent.selector, CashFlowChartComponent);



// WEBPACK FOOTER //
// ./src/application/scene/authorized/scene/dashboard/component/cash-flow-chart/index.js